import gql from 'graphql-tag'

export const CONFIRM_RECEIVE_OF_POINT_EXCHANGE_REQUEST_GQL = gql`
  mutation callConfirmReceiveOfPointExchange ($id: Int!, $code: String!) {
    confirmReceiveOfPointExchange(id: $id, code: $code)
  }
`
